import { memo } from 'react';

import classNames from 'classnames';

import { TRangeEdge } from '../hooks/useDateRangeSelection';

import style from '../dateRangeCalendar.module.scss';

/** Как ячейка часа выглядит относительно графика, выбора и текущего времени */
export type THourCellState = {
    isWorking: boolean;
    isInRange: boolean;
    /** Края диапазона в этой ячейке: оба сразу, если начало и конец в одном часе */
    edges: TRangeEdge[];
    isNow: boolean;
};

type TProps = THourCellState & {
    /** Подпись края диапазона (`09:20`) — вместо часа, когда в ячейке начало/конец */
    label: string;
    onClick: () => void;
};

/** Номер тапа, которым ставится край: начало — первый, окончание — второй */
const EDGE_NUMBER: Record<TRangeEdge, number> = { start: 1, end: 2 };

export const HourCell = memo(({ label, isWorking, isInRange, edges, isNow, onClick }: TProps) => (
    <button
        type="button"
        className={classNames(style['hour-cell'], {
            [style['hour-cell--working']]: isWorking,
            [style['hour-cell--in-range']]: isInRange,
            [style['hour-cell--edge']]: edges.length > 0,
            [style['hour-cell--now']]: isNow,
        })}
        onClick={onClick}
        aria-label={label}
    >
        {edges.length > 0 ? (
            // Край диапазона отмечен номером тапа; точное время видно в шапке и панели минут
            <span className={style['hour-cell__mark']}>
                {edges.map((edge) => EDGE_NUMBER[edge]).join(' ')}
            </span>
        ) : (
            <>
                <span>{label}</span>
                {isNow && <span className={style['hour-cell__now']}>сейчас</span>}
            </>
        )}
    </button>
));

HourCell.displayName = 'HourCell';
